<template>
  <div>
    <div v-if="!disabled" class="webcamH">
      <web-cam
        ref="webcam"
        :width="width"
        :height="height"
        :device-id="deviceId"
        @error="onError"
        @started="started"
        @cameras="onCameras"
        @video-live="onStarted"
      />
    </div>

    <slot v-if="checkedWebCam || disabled" :name="get_slot_name"></slot>

    <vpreloader v-else width="2" size="64" />
  </div>
</template>

<script>
import { WebCam } from 'vue-web-cam';
// import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';

export default {
  name: 'VtakeIntervalPhotos',

  components: {
    WebCam: WebCam
  },

  // mixins: [SafariBrowserDetector],

  props: {
    interval: {
      // in miliseconds
      type: Number,
      default: 15000
    },

    width: {
      type: Number,
      default: 1280
    },

    height: {
      type: Number,
      default: 720
    },

    disabled: {
      type: Boolean,
      default: false
    },

    allowPass: {
      type: Boolean,
      default: false
    },

    screenByStart: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      timerMakePhotoId: 0,
      webCamAvailable: false,
      deviceId: null,
      checkedWebCam: false,
      isScreenByStart: false,
      isStarted: false,
      checkOnstartedInterval: null,
      isDisabled: false
    };
  },

  computed: {
    get_slot_name() {
      return this.webCamAvailable || this.disabled || this.allowPass ? 'enabled' : 'disabled';
    }

    // isHide() {
    //   if (!this.disabled) {
    //     return false;
    //   }

    //   return this.checkedWebCam && this.disabled;
    // }
  },

  beforeDestroy() {
    this.clearTimer();
  },

  methods: {
    started() {
      this.isDisabled = this.disabled;
      if (this.disabled) {
        this.$refs.webcam.stop();
        console.log('disabled');
        return false;
      }

      setTimeout(() => {
        this.checkOnstartedInterval = setInterval(() => {
          if (!this.isStarted) {
            this.onStarted();
          } else {
            clearInterval(this.checkOnstartedInterval);
          }
        }, 5000);
      }, 5000);
    },

    onStarted() {
      if (this.disabled) {
        this.checkedWebCam = true;
        this.webCamAvailable = true;

        if (this.timerMakePhotoId) {
          this.clearTimer();
        }

        return;
      }

      if (this.isStarted && this.timerMakePhotoId) {
        return;
      }
      this.isStarted = true;
      this.webCamAvailable = true;
      this.timerMakePhotoId = setInterval(this.makePhoto, this.interval);
      this.checkedWebCam = true;
      this.$emit('on_started');

      this.$nextTick().then(() => {
        if (!this.isScreenByStart) {
          this.makePhoto();
          this.isScreenByStart = true;
        }
      });
    },

    onError() {
      this.clearTimer();
      this.webCamAvailable = this.disabled || this.allowPass ? true : false;
      this.checkedWebCam = true;
      this.$emit('on_error');
    },

    onCameras(cameras) {
      const first = cameras[0];
      if (first) {
        this.deviceId = first.deviceId;
      }
    },

    makePhoto() {
      if (this.disabled) {
        return;
      }

      const picture = this.$refs.webcam.capture();
      if (picture && picture.length < 10) {
        this.$refs.webcam.ctx = null;
      }
      this.$emit('set_photo', picture);
      this.$refs.webcam.loadCamera();
    },

    clearTimer() {
      clearInterval(this.timerMakePhotoId);
      if (this.checkOnstartedInterval) {
        clearInterval(this.checkOnstartedInterval);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.width-100 {
  width: 100%;
  height: 100%;
}

.webcamH {
  visibility: hidden;
  position: fixed;
  left: 0;
  right: 0;
  max-width: 100vw;
  max-height: 100vh;
}
</style>
